import { render } from "./ProjectTreeItem.vue?vue&type=template&id=22a4e23e"
import script from "./ProjectTreeItem.vue?vue&type=script&lang=js"
export * from "./ProjectTreeItem.vue?vue&type=script&lang=js"

import "./ProjectTreeItem.vue?vue&type=style&index=0&id=22a4e23e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__